import React, { Fragment } from 'react';
import Helmet from 'react-helmet';

import CheckoutHeader from './components/CheckoutHeader';
import MembershipsCart from './components/MembershipsCart';
import CheckoutLayoutContainer from './components/CheckoutLayoutContainer/CheckoutLayoutContainer';
import useScrollToTop from '../../../../../hooks/useScrollToTop';

const Checkout = () => {
  useScrollToTop([]);

  return (
    <Fragment>
      <Helmet>
        <title>Checkout &ndash; Waldo Photos</title>
      </Helmet>

      <CheckoutLayoutContainer>
        <div className="sticky-top">
          <CheckoutHeader />
        </div>

        <div className="flex-auto py-3 px-2">
          <MembershipsCart />
        </div>
      </CheckoutLayoutContainer>
    </Fragment>
  );
};

export default Checkout;
